var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "73mm",
    height: "78mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 7300 7800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6005 2581l-3399 0 0 418 3399 0 0 -418zm1045 -2545l-5450 0 -210 0 0 210 0 3804 0 627 0 578 420 0 0 -578 0 -627 0 -3482 0 -112 112 0 4806 0 112 0 0 112 0 6536 0 112 -112 0 -1798 0 -920 0 -557 0 0 421 557 0 920 0 2120 0 210 0 0 -210 0 -7181 0 -210 -210 0zm-6619 5779l1045 1072 26 27 26 -26 0 0 1966 -1921 53 -53 52 54 257 264 52 53 -54 52 -2176 2128 -22 21 0 0 -109 106 -54 53 -52 -54 -128 -131 -1253 -1284 -52 -54 54 -52 263 -256 54 -52 52 53zm5077 -945l-264 0 -314 0 -369 0 0 418 369 0 314 0 264 0 0 -418zm497 -1144l-3399 0 0 418 3399 0 0 -418z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/claims.10569c5457e27068480d04310a1280c1.svg";
export { ForwardRef as ReactComponent };